<template>
  <div id="zespol">
    <div class="row">
      <div class="small-12 columns">
        <slick class="default-slider team-slider" ref="slick" :options="slickOptions">
          <div v-for="(item, index) in items" :key="index" class="employers-slider">
            <div class="row employee">
              <div class="small-12 medium-6 columns">
                <figure class="employee__figure">
                  <img class="employee__img" :src="item._embedded['wp:featuredmedia'][0].media_details.sizes['full'].source_url" :alt="item.title.rendered">
                </figure>
              </div>
              <div class="small-12 medium-6 columns employee__description">
                <div class="employee__title">
                  <h2 class="employee__name" v-html="item.title.rendered"></h2>
                  <div v-html="item.excerpt.rendered"></div>
                </div>
                <div v-html="item.content.rendered"></div>
              </div>
            </div>
          </div>
        </slick>
      </div>
    </div>
    <div class="row section-whitespace">
      <div class="small-12 columns">
        <h2>Nasz zespół</h2>
      </div>
      <div class="small-10 small-offset-2 columns">
        <div class="row">
          <div class="small-12 medium-4 margin-tp-2 margin-bt-2 columns" v-for="(item, index) in items" :key="index">
            <h3 class="margin-both-0" v-html="item.title.rendered"></h3>
            <div v-html="item.excerpt.rendered"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  props: ['responsiveItems'],
  data () {
    return {
      items: [],
      slickOptions: {
        slidesToShow: 1,
        arrows: true,
        infinite: false,
        dots: false,
        mobileFirst: true,
        nextArrow: '<button type="button" class="slider__arrow slider__arrow--next"><img src="/static/icons/arrow.svg"></button>',
        prevArrow: '<button type="button" class="slider__arrow slider__arrow--prev"><img src="/static/icons/arrow.svg"></button>',
        responsive: [
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    }
  },
  components: {
    Slick
  },
  beforeCreate: function () {
    this.$http.get(`wp/v2/team?per_page=100&_embed`).then(response => {
      for (let post in response.data) {
        this.items.push(response.data[post])
      }
    }, error => { console.log(error) })
  },
  beforeUpdate () {
    this.$refs.slick.destroy()
  },
  updated () {
    this.$refs.slick.create()
  }
}
</script>

<style lang="sass">
  @import '../../node_modules/slick-carousel/slick/slick.css';
</style>



// WEBPACK FOOTER //
// src/components/Team.vue